import { render, staticRenderFns } from "./DispatchCenter.vue?vue&type=template&id=07da94d2&"
import script from "./DispatchCenter.vue?vue&type=script&lang=js&"
export * from "./DispatchCenter.vue?vue&type=script&lang=js&"
import style0 from "./DispatchCenter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports